/* "여행자들의 엽서" 리뷰 카드(snippets/jd-review-postcard.liquid) 공통 인터랙션.
   snippets/judgeme-diary-reviews.liquid(투어 페이지)와 sections/parangtour.liquid(홈페이지)
   양쪽에서 공유. 페이지마다 카드를 감싸는 컨테이너 id/class는 다르지만(#judgeme_product_reviews,
   #reviews) 카드 자체 마크업(.jd-pc, .jd-review-lightbox 등)은 동일하고, 한 페이지에는 둘 중
   하나만 존재하므로 document 전체를 대상으로 동작해도 안전함. */
(function(){
  function initReadMore(){
    document.querySelectorAll('.jd-pc').forEach(function(card){
      var quote = card.querySelector('.jd-quote');
      var btn = card.querySelector('.jd-more');
      if (!quote || !btn) return;
      if (quote.scrollHeight > quote.clientHeight + 2) {
        btn.classList.add('jd-show');
      }
      btn.addEventListener('click', function(){
        var expanded = quote.classList.toggle('jd-expanded');
        btn.textContent = expanded ? '접기' : '더 보기';
      });
    });
  }

  function initLightbox(){
    var lightbox = document.querySelector('.jd-review-lightbox');
    if (!lightbox) return null;
    var lightboxImg = lightbox.querySelector('img');

    function openLightbox(src, alt){
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.classList.add('jd-open');
    }
    function closeLightbox(){
      lightbox.classList.remove('jd-open');
      lightboxImg.src = '';
    }
    lightbox.addEventListener('click', function(e){
      if (e.target === lightbox || e.target.closest('.jd-review-lightbox-close')) closeLightbox();
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeLightbox();
    });
    return openLightbox;
  }

  function initPhotostacks(openLightbox){
    document.querySelectorAll('.jd-pc-photostack').forEach(function(stack){
      var topZ = 10;
      var photos = stack.querySelectorAll('.jd-stack-photo');

      // 사진 실제 비율(세로/가로 무관)에 맞춰 스택 높이를 다시 계산 —
      // 4:3 가로 틀에 억지로 맞추면 세로 사진 양옆에 여백이 생기는 문제를 방지.
      // 스택 안의 사진들은 각자 고정된 top 오프셋을 갖고 있으므로(앞으로 가져와도
      // 위치 자체는 안 바뀜), 모든 사진 중 "top 오프셋 + 그 사진의 실제 높이"가
      // 가장 큰 값을 기준으로 컨테이너 높이를 잡아야 어떤 사진을 앞으로 가져와도
      // 별점을 안 가림. ResizeObserver + complete 체크 + load 이벤트를 전부 걸어서
      // 이미지 로딩 타이밍(특히 loading="lazy")과 상관없이 확실히 계산되게 함.
      function recomputeStackHeight(){
        var maxBottom = 0;
        photos.forEach(function(photo){
          var img = photo.querySelector('img');
          if (!img || !img.naturalWidth) return;
          var photoWidth = stack.getBoundingClientRect().width * 0.55;
          var photoHeight = photoWidth * (img.naturalHeight / img.naturalWidth);
          var topOffset = parseFloat(getComputedStyle(photo).top) || 0;
          maxBottom = Math.max(maxBottom, topOffset + photoHeight);
        });
        if (maxBottom > 0) stack.style.height = Math.round(maxBottom + 16) + 'px';
      }

      photos.forEach(function(photo){
        var img = photo.querySelector('img');
        if (!img) return;
        if ('ResizeObserver' in window) {
          new ResizeObserver(recomputeStackHeight).observe(img);
        }
        if (img.complete && img.naturalWidth) {
          recomputeStackHeight();
        } else {
          img.addEventListener('load', recomputeStackHeight);
        }
      });
      window.addEventListener('resize', recomputeStackHeight);

      function bringToFront(photo){
        topZ += 1;
        photo.style.zIndex = topZ;
        photo.classList.add('jd-stack-bump');
        setTimeout(function(){ photo.classList.remove('jd-stack-bump'); }, 350);
      }

      photos.forEach(function(photo){
        photo.addEventListener('click', function(){
          bringToFront(photo);
          var img = photo.querySelector('img');
          if (img && openLightbox) openLightbox(img.src, img.alt);
        });
      });

      if (photos.length > 1 && 'IntersectionObserver' in window) {
        var demoed = false;
        var observer = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if (entry.isIntersecting && !demoed) {
              demoed = true;
              setTimeout(function(){
                bringToFront(photos[photos.length - 1]);
              }, 550);
              observer.disconnect();
            }
          });
        }, { threshold: 0.6 });
        observer.observe(stack);
      }
    });
  }

  initReadMore();
  var openLightbox = initLightbox();
  initPhotostacks(openLightbox);
})();
